export interface Messages {
  id: string;
  subject: string;
  sender: string;
  senderName: string;
  email: string;
  messageType: string;
  sentOn: Date;
  personId: string;
  teamId: string;
}

export class ResultModel {
  results: Messages[];
  rowCount: number;
}

export interface MessageContent {
  id: string;
  subject: string;
  html: string;
}
export enum MessageType {
  TeamEmail = 'Team Email',
  TeamInvitation = 'Team Invitation',
  LineupForm = 'Lineup Form',
  TeamSurvey = 'Team Survey',
  Evaluation = 'Evaluation',
  SystemMessage = 'System Message',
  Email = 'Email',
  GroupEmail = 'Group Email'
}
